package com.sweetlime.dungeonamigo.presentation.navigation

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.ui.unit.dp
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AutoStories
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Shield
import androidx.compose.material.icons.filled.SportsEsports
import androidx.compose.material.icons.outlined.AutoStories
import androidx.compose.material.icons.outlined.Person
import androidx.compose.material.icons.outlined.Shield
import androidx.compose.material.icons.outlined.SportsEsports
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import cafe.adriel.voyager.core.screen.Screen
import com.sweetlime.dungeonamigo.presentation.features.character.CharacterListScreen
import org.koin.compose.koinInject
import com.sweetlime.dungeonamigo.presentation.features.compendium.CompendiumScreen
import com.sweetlime.dungeonamigo.presentation.features.dice.DiceRollerSheet
import com.sweetlime.dungeonamigo.presentation.features.dice.DiceViewModel
import com.sweetlime.dungeonamigo.presentation.features.profile.ProfileScreen
import com.sweetlime.dungeonamigo.presentation.features.session.SessionLobbyScreen
import com.sweetlime.dungeonamigo.presentation.ui.components.AppHeader
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors

object MainScreen : Screen {
    @Composable
    override fun Content() {
        val navController: NavigationController = koinInject()
        val diceVm: DiceViewModel = koinInject()
        val requestedTab by navController.requestedTab.collectAsState()
        var selectedTab by rememberSaveable { mutableIntStateOf(0) }
        var showDiceSheet by remember { mutableStateOf(false) }

        LaunchedEffect(requestedTab) {
            requestedTab?.let { tab ->
                selectedTab = tab
                navController.consumeRequest()
            }
        }

        val itemColors = NavigationBarItemDefaults.colors(
            selectedIconColor   = BrandColors.Ember,
            selectedTextColor   = BrandColors.Ember,
            unselectedIconColor = BrandColors.SlateLight,
            unselectedTextColor = BrandColors.SlateLight,
            indicatorColor      = BrandColors.Ember.copy(alpha = 0.12f),
        )

        Scaffold(
            containerColor = BrandColors.Vault,
            topBar = { AppHeader(onDiceClick = { showDiceSheet = true }) },
            bottomBar = {
                NavigationBar(
                    containerColor = Color(0xFF14141E).copy(alpha = 0.96f),
                    tonalElevation = 0.dp,
                ) {
                    NavigationBarItem(
                        selected = selectedTab == 0,
                        onClick = { selectedTab = 0 },
                        label = { Text("Characters") },
                        colors = itemColors,
                        icon = { Icon(if (selectedTab == 0) Icons.Filled.Shield else Icons.Outlined.Shield, "Characters") },
                    )
                    NavigationBarItem(
                        selected = selectedTab == 1,
                        onClick = { selectedTab = 1 },
                        label = { Text("Session") },
                        colors = itemColors,
                        icon = { Icon(if (selectedTab == 1) Icons.Filled.SportsEsports else Icons.Outlined.SportsEsports, "Session") },
                    )
                    NavigationBarItem(
                        selected = selectedTab == 2,
                        onClick = { selectedTab = 2 },
                        label = { Text("Compendium") },
                        colors = itemColors,
                        icon = { Icon(if (selectedTab == 2) Icons.Filled.AutoStories else Icons.Outlined.AutoStories, "Compendium") },
                    )
                    NavigationBarItem(
                        selected = selectedTab == 3,
                        onClick = { selectedTab = 3 },
                        label = { Text("Profile") },
                        colors = itemColors,
                        icon = { Icon(if (selectedTab == 3) Icons.Filled.Person else Icons.Outlined.Person, "Profile") },
                    )
                }
            },
        ) { innerPadding ->
            Box(Modifier.padding(innerPadding)) {
                AnimatedContent(
                    targetState = selectedTab,
                    transitionSpec = { fadeIn() togetherWith fadeOut() },
                ) { tab ->
                    when (tab) {
                        0 -> CharacterListScreen.Content()
                        1 -> SessionLobbyScreen.Content()
                        2 -> CompendiumScreen.Content()
                        3 -> ProfileScreen.Content()
                    }
                }
            }
        }

        if (showDiceSheet) {
            DiceRollerSheet(vm = diceVm, onDismiss = { showDiceSheet = false })
        }
    }
}
